import { Color } from '@tmh-website/shared/colors';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';

interface ScrollIndicatorProps {
  $isActive: boolean;
  $position: 'left' | 'right';
  $fadeColor: Color;
  $iconColor: Color;
}

export const ScrollIndicator = styled.button<ScrollIndicatorProps>`
  position: relative;
  ${props =>
    props.$position === 'left'
      ? css`
          margin-right: -64px;
        `
      : css`
          margin-left: -64px;
        `};
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.$position === 'left' ? 'flex-start' : 'flex-end')};
  width: 64px;
  min-width: 64px;
  min-height: 32px;
  padding: 0;
  font-size: 16px;
  color: ${props => props.theme.color[props.$iconColor]};
  cursor: pointer;
  background: linear-gradient(
    to ${props => props.$position},
    ${props => transparentize(1, props.theme.color[props.$fadeColor])} 0%,
    ${props => props.theme.color[props.$fadeColor]} 50%
  );
  background-position: ${props => (props.$position === 'left' ? '80%' : '20%')} 0%;
  background-size: 200% 100%;
  border: none;
  opacity: ${props => (props.$isActive ? 1 : 0)};
  transition: all ${props => props.theme.transitionTiming};
  transition-property: background-position opacity color;
  ${props =>
    props.$isActive === false &&
    css`
      pointer-events: none;
    `}

  &:hover {
    background-position: ${props => (props.$position === 'left' ? '100%' : '0%')} 0%;
  }
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-shrink: 1;
  min-height: 32px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;

  &::-webkit-scrollbar-track {
    display: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
`;

export const EntriesContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: stretch;
  align-self: stretch;
`;
